const messages = {
  en: {
    global: {
      add: 'add',
      specie: 'specie',
      edit: 'edit',
      new: 'new',
      delete: 'delete',
      yes: 'yes',
      no: 'no',
      moreInfo: 'more info',
      updateAvailable: 'A new update is now available',
      update: 'update',
      cancel: 'cancel'
    },
    page: {
      localization: 'Localization',
      team: 'Team',
      plot: 'Plot',
      event: 'Event'
    },
    error: {
      errorPlotType: 'Please insert number, type and GPS',
      errorEventType: 'Please insert number and type',
      errorPlotNum: 'Plot Number already exists',
      errorEventNum: 'Event number already exists',
      errorDist: 'No coords are present! Please set them in 3 step and try again',
      errorRange: 'Value out of range',
      dataCheck: 'The information inserted is not valid! Please check the fields',
      municipalityCheck: 'Please compile fields municipality and parcel',
      gps: {
        errorPermissionDenied: 'User denied the request for Geolocation',
        errorPositionUnavailable: 'Location information is unavailable',
        errorTimeout: 'The request to get user location timed out',
        errorUnknown: 'An unknown error occurred'
      }
    },
    home: {
      listPlot: 'Plot List',
      addPlot: 'Add Plot',
      map: 'Map',
      download: 'Download',
      upload: 'Upload',
      settings: 'Settings',
      credits: 'Credits',
      firstPlot: 'Add your first plot',
      deleteMsg: 'Do you want to delete this plot?',
      upMsgSuc: 'Import successfully!',
      upMsgErr: 'Please import a valid JSON file',
      downMsgSuc: 'Export successfully!',
      downMsgErr: 'Export failed',
      tiles: 'Download Area'
    },
    settings: {
      eraseDbMsg: 'Do you want to erase the database?',
      eraseDb: 'Erase database',
      selectLang: 'Select language',
      deleteTiles: 'Delete tiles',
      deleteTilesMsg: 'Do you want to delete all tiles?',
      updateDomains: 'Update domains'
    },
    map: {
      wms: 'WMS',
      default: 'Default',
      myPosition: 'My Position',
      plot: 'Plot',
      completed: 'Completed',
      radius: 'Radius',
      choosePoint: 'Choose a point on the map',
      checkConnection: 'This operation will download many files, be careful to download them with wifi connection disabled.\nOk to proceed, Cancel to abort'
    },
    localization: {
      municipality: 'Municipality',
      adminLimit: 'Admin. Unit',
      localName: 'Local Name',
      alfisCode: 'Alfis Cod',
      economy: 'Economy',
      parcel: 'Parcel',
      subParcel: 'Sub Parcel',
      descParc: 'Description of Parcel',
      // site description
      siteDesc: 'Site Description',
      exposition: 'Exposition',
      relief: 'Relief',
      rockFormation: 'Rock formation',
      litterDepth: 'Litter Depth',
      humusDepth: 'Humus Depth',
      landCover: 'Land Cover',
      // management
      management: 'Main and Specific Function',
      mainFunction: 'Main Function',
      specificFunction: 'Specific Function',
      specificFunctionDetail: 'S. Functions Details',
      // forest stand
      forestStand: 'Forest Stand',
      homogeneity: 'Homogeneity',
      managIntensity: 'Management Intensity',
      // forest stand -> development stage
      developmentStage: 'Development Stage',
      highForest: 'High Forest',
      coppice: 'Coppice',
      shrub: 'Shrub',
      // forest stand -> origin
      origin: 'Origin',
      natural: 'Natural',
      year: 'Year',
      detail: 'Types',
      // forest stand -> regeneration
      regeneration: 'Regeneration',
      originNatural: 'Natural',
      meanH: 'Mean H',
      meanD: 'Mean D',
      seedlingNr: 'Nr Seed',
      mainSpecies: 'Main Species',
      // health
      health: 'Health',
      damageType: 'Damage Type',
      damageIntensity: 'Damage Intensity',
      damageArea: 'Damage Area',
      damageMainReason: 'Main Reason',
      deadTree: 'Dead Wood',
      // biodiversity
      biodiversity: 'Biodiversity',
      actualVegetation: 'Actual Vegetation',
      potentialVegetation: 'Potential Vegetation',
      naturality: 'Naturality',
      biodiversityRisk: 'Risk For Biodiversity',
      biotope: 'Biotope',
      hcv: 'HCV',
      deadWood: 'Dead Wood',
      habitat: 'Habitat Spec',
      endangeredType: 'Endangered Type',
      endangeredPlants: 'Endangered Plants',
      endangeredAnimals: 'Endangered Animals',
      // herbs
      herbs: 'Herbs',
      herbsType: 'Herbs Type',
      herbsSpecie: 'Herbs Specie',
      herbsArea: 'Herbs Area'
    },
    teams: {
      name: 'Name',
      surname: 'Surname',
      addMember: 'Add member'
    },
    plot: {
      plotNum: 'Plot n°',
      eventNum: 'Event n°',
      plotSample: 'Plot loc',
      eventLoc: 'Event loc',
      plotType: 'Plot Type',
      elevation: 'Elevation (ma.s.l)',
      plotTypeList: {
        forest: 'Forest',
        pastures: 'Pastures',
        shrubs: 'Shrubs',
        nonwood: 'Non Wood'
      },
      eventTypeList: {
        forestFire: 'Forest Fire',
        erosion: 'Erosion',
        others: 'Others',
        illegalCutting: 'Illegal Cutting'
      },
      slope: 'Slope',
      gps: 'GPS',
      note: 'Note'
    },
    typeInfo: {
      radius: 'radius',
      area: 'area',
      successMsg: 'Plot successfully saved!',
      plotArea: 'Plot Area',
      species: 'Species',
      woodSpecies: 'Species',
      trees: 'Woods',
      cover: {
        pastures: 'Pastures Cover',
        shrubs: 'Shrubs Cover',
        nonwood: 'Land Cover'
      },
      // forest
      forestType: 'Forest Type',
      managSys: 'Form of Government',
      ageClass: 'Age Class',
      crownDensity: 'Crown Density',
      verticalStruct: 'Structure Vert',
      // forest table
      diameter: 'DBH',
      azimuth: 'Azimuth (degrees)',
      quality: 'Quality',
      addDamage: 'Add damage',
      // forest damage
      damage: 'Damage',
      damageType: 'Damage Type',
      damageLevel: 'Damage Level',
      damageDead: 'Dead Wood',
      // pasture
      spGramin: 'SP Gramin',
      spLegum: 'SP Legum',
      spOthers: 'SP Others',
      weightN: 'Weight N',
      weightE: 'Weight E',
      weightS: 'Weight S',
      weightW: 'Weight W',
      fireState: 'State of Fire',
      stoneCover: 'Stone Cover',
      pastureUser: 'User',
      pastureUtilizPeriod: 'Utilization Period',
      pastureType: 'Types',
      avh: 'Av. H.',
      // shrub - nonwood
      specieAvd: 'Av. D.',
      specieAvh: 'Av. H.',
      specieIndividuals: 'N° of Individuals',
      // event
      frequency: 'Frequency',
      effect: 'Effect',
      // forest fire
      areaFire: 'Area',
      year: 'Year',
      // erosion
      areaErosion: 'Area',
      erosionType: 'Erosion Type',
      origin: 'Origin',
      trend: 'Trend',
      // other
      areaOther: 'Area',
      otherType: 'Other Type',
      // illegal cut
      treesNr: 'Woods Nr',
      totalVolume: 'Total Vol'
    }
  },
  al: {
    global: {
      add: 'shto',
      specie: 'lloj',
      edit: 'Perpuno',
      new: 'E re',
      delete: 'fshij',
      yes: 'po',
      no: 'jo',
      moreInfo: 'më shumë informacion',
      updateAvailable: 'Një azhurnim i ri është tani në dispozicion',
      update: 'azhurnuar',
      cancel: 'anulo'
    },
    page: {
      localization: 'Vendndodhja',
      team: 'Ekipi',
      plot: 'Siperfaqet prove',
      event: 'Ngjarjet ne Siperfaqe prove'
    },
    error: {
      errorPlotType: 'Fut nr., tipin dhe GPS',
      errorEventType: 'Fut nr. dhe tipin',
      errorPlotNum: 'Ngastrat nr. ekzistues',
      errorEventNum: 'Numri i ngjarjes ekziston tashmë',
      errorDist: 'Asnjë koordinate nuk është e pranishme! Ju lutemi vendosni ato në 3 hapa dhe provoni përsëri',
      errorRange: 'Vlera jashtë nivelit',
      dataCheck: 'Informacioni i futur nuk është i vlefshëm! Ju lutemi kontrolloni fushat',
      municipalityCheck: 'Ju lutem plotësoni fushën bashkia dhe parc',
      gps: {
        errorPermissionDenied: 'Përdoruesit i refuzohet  kërkesa për Gjeolokacion',
        errorPositionUnavailable: 'Informacioni për vendndodhjen nuk është i disponueshëm',
        errorTimeout: 'Përfundoi koha për marrjen e informacionit për vendndodhjen e përdoruesit.',
        errorUnknown: 'Ka ndodhur një gabim i panjohur'
      }
    },
    home: {
      listPlot: 'Lista Siperfaqe prove',
      addPlot: 'Shto Siperfaqe prove',
      map: 'Harte',
      download: 'Shkarko',
      upload: 'Ngarkoni',
      settings: 'Parametra',
      credits: 'Kredite',
      firstPlot: 'Shtoni provën tuaj të parë',
      deleteMsg: 'Hiqe këtë sipërfaqe(tokë)?',
      upMsgSuc: 'U importua me sukses!',
      upMsgErr: 'Ju lututem importoni nje file JSON te vlefshem',
      downMsgSuc: 'U dergua me sukses!',
      downMsgErr: 'Dergesa deshtoj',
      tiles: 'Shkarkoni sipërfaqe'
    },
    settings: {
      eraseDbMsg: 'Deshironi te fshini databazen?',
      eraseDb: 'Fshij databazen',
      selectLang: 'Zgjidh gjuhen',
      deleteTiles: 'Fshij përmbajtjen',
      deleteTilesMsg: 'A doni të fshini të gjitha përmbajtjen?',
      updateDomains: 'Përditësimin domains'
    },
    map: {
      wms: 'WMS',
      default: 'Konfigurimi Standart',
      myPosition: 'Pozicioni im',
      plot: 'Siperfaqet prove',
      completed: 'I përfunduar',
      radius: 'Rrzja',
      choosePoint: 'Zgjidhni një pikë në hartë',
      checkConnection: 'Ky operacion do të shkarkojë shumë skedarë, kini kujdes kur i shkarkoni sigurohuni qe interneti të mos te jete i lidhur.\n Ok vazhdoni, Cancel për ta ndaluar'
    },
    localization: {
      municipality: 'Bashkia',
      adminLimit: 'Njesia Administrative',
      localName: 'Emri lokal',
      alfisCode: 'Kodi SISP',
      economy: 'Ekonomia Pyjore',
      parcel: 'Parc',
      subParcel: 'NenParc',
      descParc: 'Pershkrimi Parcelar',
      // site description
      siteDesc: 'Pershkrimi i Stacionit',
      exposition: 'Kundrejtimi',
      relief: 'Relievi',
      rockFormation: 'Shkembi amnor',
      litterDepth: 'Thellesia legushes',
      humusDepth: 'Thellesia Humusit',
      landCover: 'Mbulesa e Tokës',
      // management
      management: 'Funksionet kryesore dhe specifike',
      mainFunction: 'Funksioni kryesor',
      specificFunction: 'Produktet Specifike',
      specificFunctionDetail: 'Funksion specifik',
      // forest stand
      forestStand: 'Grumbullit Pyjor',
      homogeneity: 'Homogjeniteti',
      managIntensity: 'Intensiteti i Menaxhimit',
      // forest stand -> development stage
      developmentStage: 'Fazat e zhvillimit',
      highForest: 'Trungishte',
      coppice: 'Cungishte',
      shrub: 'Shkurret',
      // forest stand -> origin
      origin: 'Origjina',
      natural: 'Natyrore',
      year: 'Viti',
      detail: 'Tipi',
      // forest stand -> regeneration
      regeneration: 'Rigjenerimi',
      originNatural: 'Natyrore',
      meanH: 'Lartesia mes.',
      meanD: 'Diametri',
      seedlingNr: 'Nr filizave',
      mainSpecies: 'Llojet kryesore',
      // health
      health: 'Gjëndja Shëndetësore',
      damageType: 'Tipi Demtimit',
      damageIntensity: 'Intensiteti i dëmtimit',
      damageArea: 'Sipërfaqja e dëmtuar',
      damageMainReason: 'Arsyeja kryesore',
      deadTree: 'Dru te Tharë',
      // biodiversity
      biodiversity: 'Biodiversiteti',
      actualVegetation: 'Vegjetacioni aktual',
      potentialVegetation: 'Vegjetacioni potencial',
      naturality: 'Shkalla e natyralitetit',
      biodiversityRisk: 'Rreziqet e biodiversitetit',
      biotope: 'Biotipi',
      hcv: 'Vlera konservuese te larta',
      deadWood: 'Drurët e tharë',
      habitat: 'Habitate spec',
      endangeredType: 'Lloji I rrezikuara',
      endangeredPlants: 'Bimësia e rrezikuar',
      endangeredAnimals: 'Kafshët e rrezikuara',
      // herbs
      herbs: 'Bimësia barishtore',
      herbsType: 'Lloji',
      herbsSpecie: 'Specia',
      herbsArea: 'Siperfaqja'
    },
    teams: {
      name: 'Emer',
      surname: 'Mbiemer',
      addMember: 'Shto anëtar'
    },
    plot: {
      plotNum: 'Sip. Prove nr.',
      eventNum: 'Numri i ngjarjes',
      plotSample: 'Siperfaqja prove',
      eventLoc: 'Vendndodhja e ngjarjes',
      plotType: 'Lloj Sip. Prove',
      elevation: 'Lartesia mbi niv. Detit',
      plotTypeList: {
        forest: 'Pyje',
        pastures: 'Kullota',
        shrubs: 'Shkurret',
        nonwood: 'Prod.JoDrusore'
      },
      eventTypeList: {
        forestFire: 'Zjarr pyjor',
        erosion: 'Erozioni',
        others: 'Të tjera',
        illegalCutting: 'Prerje te paligjshme'
      },
      slope: 'Pjerrësi',
      gps: 'GPS',
      note: 'Shenime'
    },
    typeInfo: {
      radius: 'rrzja',
      area: 'Siperfaqja',
      successMsg: 'Ruajtje me sukses!',
      plotArea: 'Sip. Prove',
      species: 'Lloji',
      woodSpecies: 'Lloji Pyjor',
      trees: 'Dru',
      cover: {
        pastures: 'Mbulese me Kullota',
        shrubs: 'Mbulesa me Shkurret',
        nonwood: 'Mbulesa'
      },
      // forest
      forestType: 'Tipi i Pyllit',
      managSys: 'Forma e Qeverisjes',
      ageClass: 'Klasa e Moshes',
      crownDensity: 'Kuror Dendesia',
      verticalStruct: 'Struktura Vert',
      // forest table
      diameter: 'Diameter',
      azimuth: 'Azimuti (grade)',
      quality: 'Cilesia',
      addDamage: 'Shto dëmtimin',
      // forest damage
      damage: 'Dëmtimi',
      damageType: 'Tipi Demtimit',
      damageLevel: 'Niveli i dëmtimit',
      damageDead: 'Dru te Tharë',
      // pasture
      spGramin: 'Gramin',
      spLegum: 'Legum',
      spOthers: 'Te tjera',
      weightN: 'Pesha V',
      weightE: 'Pesha L',
      weightS: 'Pesha J',
      weightW: 'Pesha P',
      fireState: 'Gjendja e Zjarreve',
      stoneCover: 'Mbulesa me Gure',
      pastureUser: 'Përdorimi',
      pastureUtilizPeriod: 'Periudha e perdorimit',
      pastureType: 'Tipi i kullotes',
      avh: 'Lart.mes.',
      // shrub - nonwood
      specieIndividuals: 'N° i bimëve',
      specieAvd: 'Diam mes.',
      specieAvh: 'Lartesia mes.',
      // event
      frequency: 'Frekuenca',
      effect: 'Efekti',
      // forest fire
      areaFire: 'Sip. djegur',
      year: 'Viti',
      // erosion
      areaErosion: 'Sip. eroduar',
      erosionType: 'Tipi i erozionit',
      origin: 'Origjina',
      trend: 'Tendenca erozionit',
      // other
      areaOther: 'Sip. e demtuar',
      otherType: 'Tipe të tjera',
      // illegal cut
      treesNr: 'Dru Nr',
      totalVolume: 'Volumi i prere'
    }
  }
}

export default messages
